import React, { useEffect, useState } from 'react';
import { subscribeToSession } from '../sessionService';
import { Session } from '../types';

interface FinishedWaitingScreenProps {
  sessionCode: string;
  userName: string;
  onBothFinished: (session: Session) => void;
}

const FinishedWaitingScreen: React.FC<FinishedWaitingScreenProps> = ({
  sessionCode,
  userName,
  onBothFinished,
}) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const unsubscribe = subscribeToSession(sessionCode, (session) => {
      if (session.status === 'finished') {
        onBothFinished(session);
      }
    });
    return () => unsubscribe();
  }, [sessionCode, onBothFinished]);

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(d => d.length >= 3 ? '' : d + '.');
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-6 py-12 bg-dinder-blue">
      <div className="w-full max-w-sm text-center">

        <div className="text-8xl mb-6">🍿</div>
        <h2 className="text-3xl font-extrabold text-white mb-3">You're done!</h2>
        <p className="text-blue-100 text-lg mb-2">Waiting for your partner to finish{dots}</p>
        <p className="text-white/40 text-sm mt-8">Results will appear automatically when they're done.</p>

        <div className="flex justify-center gap-3 mt-12">
          {[0, 1, 2].map(i => (
            <div
              key={i}
              className="w-3 h-3 rounded-full bg-dinder-pink"
              style={{ animation: `bounce 1.2s ease-in-out ${i * 0.2}s infinite` }}
            />
          ))}
        </div>

        <style>{`
          @keyframes bounce {
            0%, 100% { transform: translateY(0); opacity: 0.4; }
            50% { transform: translateY(-12px); opacity: 1; }
          }
        `}</style>

      </div>
    </div>
  );
};

export default FinishedWaitingScreen;